<template>
  <div>
    <div
      v-if="hasError('required')"
      :class="$style.error"
      v-test="'_form-element-error'"
    >
      <BaseText
        color="error"
        size="s"
      >
        *{{ $t('global.validations.required') }}
      </BaseText>
    </div>
    <div
      v-else
      :class="[
        $style.alert,
        {
          [$style.error]: !!errors.length
        }
      ]"
      v-test="'_form-element-error'"
    >
      <BaseText
        bold
        size="s"
      >
        {{ $t('global.password_validation.heading') }}
      </BaseText>
      <div
        v-for="(validation, index) in requiredValidations"
        :key="index"
        :class="$style.passwordItem"
      >
        <BaseText size="s">
          {{ $t(`global.password_validation.${validation}`, { length: 8 }) }}
        </BaseText>
        <BaseIcon
          v-show="!hasSilentError(validation)"
          name="check"
          color="success"
          size="s"
        />
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  errors: any[];
  silentErrors: any[];
}>();

const requiredValidations = [
  'minLength',
  'containsUppercase',
  'containsLowercase',
  'containsNumber',
];
const hasError = (validation: string) =>
  !!props.errors.find((error) => error.$validator === validation);
const hasSilentError = (validation: string) =>
  !!props.silentErrors.find((error) => error.$validator === validation);
</script>

<style
  lang="scss"
  module
>
.error {
  margin-top: $spacing * 0.5;
}

.passwordItem {
  display: flex;
  gap: $spacing * .5;
}

.alert {
  display: flex;
  flex-direction: column;
  gap: $spacing * .5;
  margin-top: $spacing * 0.5;

  &.error {
    color: var(--color-error);
  }
}
</style>
